import { Component } from '@angular/core';
import { BaseLayoutComponent } from '../../base-layout.component';

@Component({
  selector: 'app-data-connection',
  standalone: true,
  imports: [],
  templateUrl: './data-connection.component.html',
  styleUrl: './data-connection.component.scss'
})
export class DataConnectionComponent extends BaseLayoutComponent{

}
